import { render, staticRenderFns } from "./step_letter.vue?vue&type=template&id=bdbfbd3e&scoped=true"
import script from "./step_letter.vue?vue&type=script&lang=js"
export * from "./step_letter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdbfbd3e",
  null
  
)

export default component.exports